import React from 'react';
import {
  Avatar,
  Box,
  Card,
  CardActionArea,
  CardContent,
  Chip,
  Container,
  Grid,
  SxProps,
  Typography,
} from '@mui/material';

import { TP_COLORS } from '../../../constants';
import { getAuthState } from '../../../store/AuthSlice';
import { useAppSelector } from '../../../hooks';
import {
  removeAuthUserToLocalStorage,
  setAuthUserToLocalStorage,
} from '../../../helper';
import HeaderBar from '../../Authentication/components/HeaderBar';

const containerStyles: SxProps = {
  background:
    'linear-gradient(107.83deg, #003768 7.88%, #006C9C 41.91%, #39BFB9 82.16%)',
  minHeight: '100vh',
};

const centeredContainerStyles: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: 'calc(100vh - 79px)',
  paddingBottom: '15px',
};

const contentContainerStyles: SxProps = {
  borderRadius: '30px',
  padding: '32px',
  backgroundColor: TP_COLORS.white,
};

const ManageAccounts: React.FC = () => {
  // Store
  const { userMapper } = useAppSelector(getAuthState);

  const handleAccountChange = (userId: string) => {
    const selectedUser = userMapper?.find(
      (userItem) => userItem._id === userId
    );
    if (selectedUser) {
      removeAuthUserToLocalStorage();
      setAuthUserToLocalStorage(selectedUser);
      window.location.href = `${process.env.PUBLIC_URL}/`;
    }
  };

  return (
    <Box sx={containerStyles}>
      <HeaderBar />
      <Box sx={centeredContainerStyles}>
        <Container maxWidth="lg">
          <Box sx={contentContainerStyles}>
            <Grid
              container
              spacing={4}
              justifyContent="center"
              alignItems="center"
              height="calc(100vh - 200px)"
            >
              {userMapper && userMapper.length > 1
                ? userMapper.map((userItem) => {
                    const fullName = `${userItem.firstname} ${
                      userItem.lastname || ''
                    }`;
                    return (
                      <Grid item>
                        <Card
                          sx={{
                            display: 'flex',
                            height: 250,
                            width: 250,
                            borderRadius: 4,
                            boxShadow: 3,
                            position: 'relative',
                            textAlign: 'center',
                            overflow: 'visible',
                          }}
                        >
                          <CardActionArea
                            onClick={() => handleAccountChange(userItem._id)}
                          >
                            {userItem.isPrimary && (
                              <Chip
                                label="Primary"
                                color="primary"
                                size="small"
                                sx={{
                                  position: 'absolute',
                                  top: 12,
                                  right: 12,
                                  fontWeight: 500,
                                }}
                              />
                            )}

                            <CardContent>
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  marginBottom: 2,
                                }}
                              >
                                <Avatar
                                  src={userItem.avatar}
                                  sx={{
                                    width: 80,
                                    height: 80,
                                    bgcolor: 'grey.300',
                                  }}
                                />
                              </Box>

                              <Typography fontWeight="600" marginBottom="4px">
                                {fullName}
                              </Typography>

                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                {userItem.username}
                                {userItem.role
                                  ? ` (${userItem.role.name})`
                                  : null}
                              </Typography>
                            </CardContent>
                          </CardActionArea>
                        </Card>
                      </Grid>
                    );
                  })
                : null}
            </Grid>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default ManageAccounts;
